import { render, staticRenderFns } from "./myMask.vue?vue&type=template&id=2b358ce3&"
import script from "./myMask.vue?vue&type=script&lang=js&"
export * from "./myMask.vue?vue&type=script&lang=js&"
import style0 from "./myMask.vue?vue&type=style&index=0&lang=less&soped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports